import { requestData } from "./request";

//埋点
// source: '3', //来源 ： 来源 1:小程序 2:web 3:APP
// type, //类型 1:浏览 2:点击
// correlationId: cId, //关联id
// correlationType: cTp, //关联类型 1:竞价/挂牌 2:资讯 7：点击购买 8：点击出售  9：首页 10：拍卖 11：成交公告 12：价格趋势 13：全部资讯 14：个人主页
// special,
export const buryingPoint = (data) => {
  return requestData("post", "/applet/AAUser/buryingPoint", data);
};
//登陆--获取国家地区的区号
export const getZoneList = (data) => {
  return requestData("get", "/applet/ALogin/getTelephoneCodeList", data);
};
//登陆--获取验证码
export const getSMSVerificationCode = (params) => {
  return requestData("get", "/applet/ALogin/getSMSVerificationCode", params);
};

//登录
export const login = (data) => {
  return requestData("post", "/applet/ALogin/login", data);
};
//退出登录
export const logout = () => {
  return requestData("get", "/applet/oauth/logout");
};

//获取用户信息
export const getUserDetailsById = (params) => {
  return requestData("get", "/applet/user/getUserDetailsById", params);
};
//获取完整的品类树
export const getCategoryTree = (params) => {
  return requestData("get", "/common/CCategory/getCategoryTree", params);
};

//首页-获取资讯列表
export const articleRollList = (params) => {
  return requestData("get", "/applet/AArticle/articleRollList", params);
};

//首页-获取资讯列表
export const getNewHome3FilterItems = (data) => {
  return requestData("post", "/applet/AAuction/getNewHome3FilterItems", data);
};

//首页-获取竞拍的列表
export const getNewHome3GroupList3 = (data) => {
  return requestData("post", "/applet/AAuction/getNewHome3GroupList3", data);
};
//首页-获取鱿鱼第一层的数据
export const getSquidGroupList = (data) => {
  return requestData("post", "/applet/AAuction/getNewHome3GroupList4", data);
};

//首页-获取banner
export const queryAuctionSpecial = (data) => {
  return requestData("get", "/applet/ASpecial/queryAuctionSpecial", data);
};

//新闻-获取新闻列表
export const getIndustryNewsList = (params) => {
  return requestData("post", "/applet/ANews/getIndustryNewsList", params);
};
//新闻-获取新闻详情
export const getIndustryNewsDetails = (params) => {
  return requestData("post", "/applet/ANews/getIndustryNewsDetails", params);
};

//专场-详情
export const queryAuctionSpecialDetails = (params) => {
  return requestData(
    "get",
    "/applet/ASpecial/queryAuctionSpecialDetails",
    params
  );
};
//行情-获取成交公告
export const getTransactionAnnouncementList = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/getTransactionAnnouncementList",
    data
  );
};
//行情-获取价格趋势
export const getNewHistoricalTransactionData = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/getNewHistoricalTransactionData",
    data
  );
};

//行情-获取鱿鱼默认的品类品相规格
export const getSquidDefaultCategory = () => {
  return requestData("get", "/applet/AAuction/getSquidDefaultCategory");
};

//竞拍中心-获取进行中和即将开始的数量
export const getNewHome4AuctionListCount = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/getNewHome4AuctionListCount",
    data
  );
};

//竞拍中心-获取列表
export const getNewHome4AuctionList = (data) => {
  return requestData("post", "/applet/AAuction/getNewHome4AuctionList", data);
};

//发布-获取条件列表
export const getAuctionConditionList = (params) => {
  return requestData("get", "/applet/ACommon/getAuctionConditionList", params);
};
//发布-获取省市
export const getCityTree = () => {
  return requestData("get", "/common/CAuctionRegion/getCityTree");
};
//发布-上传获取密匙
export const getMd5Password = (params) => {
  return requestData("get", "/applet/getMd5Password", params);
};
//发布-获取竞价时间
export const queryAuctionSessions = (params) => {
  return requestData("get", "/applet/AAuction/queryAuctionSessions", params);
};
//发布-获取竞价时长
export const queryAuctionDuration = (params) => {
  return requestData("get", "/applet/AAuction/queryAuctionDuration", params);
};

//发布-获取冷库
export const getPublishAuctionColdStoreList = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/getPublishAuctionColdStoreList",
    data
  );
};
//发布-发布
export const publishAuction = (data) => {
  return requestData("post", "/applet/AAuction/publishAuction", data);
};

//看货记录-获取列表
export const getSelfSourceList = (data) => {
  return requestData("post", "/applet/ACommon/getSelfSourceList", data);
};
//看货记录-获取详情
export const getSelfSourceDetails = (params) => {
  return requestData("get", "/applet/ACommon/getSelfSourceDetails", params);
};

//详情页
//获取联系人的联系方式
export const getBrokerByCustomerContacts = (params) => {
  return requestData(
    "get",
    "/blade-auctionInfo/auctionInfo/getBrokerByCustomerContacts",
    params
  );
};
//获取详情
export const auctionDetails = (params) => {
  return requestData("get", "/applet/AAuction/auctionDetails", params);
};
//获取出价列表
export const getAuctionOfferPriceList = (params) => {
  return requestData(
    "get",
    "/applet/AAuction/getAuctionOfferPriceList",
    params
  );
};

//看货记录-获取列表
export const addCustomerOpportunities = (data) => {
  return requestData(
    "post",
    "/applet/customerOpportunities/addCustomerOpportunities",
    data
  );
};

//获取客户列表
export const getOptionalCustomerList = (params) => {
  return requestData("get", "/applet/ACommon/getOptionalCustomerList", params);
};
//获取主体列表
export const getUserOptionalAccountList = (params) => {
  return requestData("post", "/applet/user/getUserOptionalAccountList", params);
};

export const getSourceUserOptionalAccountList = (params) => {
  return requestData(
    "post",
    "/applet/user/getSourceUserOptionalAccountList",
    params
  );
};
//获取报名的详情
export const getAuctionApplyDetails = (params) => {
  return requestData("post", "/applet/AAuction/getAuctionApplyDetails", params);
};
//报名操作
export const auctionApply = (params) => {
  return requestData("post", "/applet/AAuction/auctionApply", params);
};
//取消报名操作
export const cancelAuctionApply = (params) => {
  return requestData("post", "/applet/AAuction/cancelAuctionApply", params);
};
//切换主体
export const switchSnbAccount = (params) => {
  return requestData("post", "/applet/AUser/switchSnbAccount", params);
};
//获取出价详情
export const getAuctionOfferPriceDetails = (params) => {
  return requestData(
    "post",
    "/applet/AAuction/getAuctionOfferPriceDetails",
    params
  );
};
//出价
export const auctionOfferPrice = (params) => {
  return requestData("post", "/applet/AOrder/auctionOfferPrice", params);
};
//购买
export const createIntentOrder = (data) => {
  return requestData("post", "/applet/newAOrder/createIntentOrder", data);
};
//报名
export const applyAuction = (data) => {
  return requestData("post", "/applet/AAuction/applyAuction", data);
};
export const getPayCodeUrl = (params) => {
  return requestData("post", "/applet/wxPay/getPayCodeUrl", params);
};
//取消报名
export const cancelAuction = (params) => {
  return requestData("post", "/applet/AAuction/cancelAuctionApply", params);
};
//核对保证金
export const checkMarginAmount = (data) => {
  return requestData("post", "/applet/AAuction/checkMarginAmount", data);
};

//个人中心相关

//查询余额等
export const queryAccountBalance = (params) => {
  return requestData("post", "/snb/snbApi/queryAccountBalance", params);
};

//获取个人中心首页的数量信息
export const getPersonalCenterQuantity = (params) => {
  return requestData("get", "/applet/AUser/getPersonalCenterQuantity", params);
};

//获取订单列表
export const getUserOrderList = (params) => {
  return requestData("get", "/applet/AAUser/getUserOrderList", params);
};
//报名货源详情
export const getAuctionAppleDetails = (params) => {
  return requestData("get", "/applet/AAuction/getAuctionAppleDetails", params);
};
//订单-查看合同
export const downloadSignFile = (params) => {
  return requestData("get", "/applet/AContract/downloadSignFile", params);
};

//订单-签署合同
export const startSigning = (params) => {
  return requestData("get", "/applet/AContract/startSigning", params);
};
export const startFirstLastStylesSigning = (params) => {
  return requestData(
    "get",
    "/applet/AContract/startFirstLastStylesSigning",
    params
  );
};

//获取订单详情
export const getOrderDetailById = (data) => {
  return requestData("post", "/applet/AOrder/getOrderDetailById", data);
};

//确认放货
export const confirmShipment = (data) => {
  return requestData("post", "/applet/newAOrder/confirmShipment", data);
};

//确认收货
export const confirmReceipt = (data) => {
  return requestData("post", "/applet/newAOrder/confirmReceipt", data);
};

//我发布的
export const getUserPublishAuctionList = (data) => {
  return requestData("post", "/applet/AUser/getUserPublishAuctionList", data);
};
//我发布的-下架
export const unshelveUserAuction = (data) => {
  return requestData("post", "/applet/AUser/unshelveUserAuction", data);
};
//我发布的-删除
export const deleteUserAuction = (params) => {
  return requestData("get", "/applet/AUser/deleteUserAuction", params);
};

//我发布的-改价
export const updateUserAuctionIprice = (data) => {
  return requestData("post", "/applet/AUser/updateUserAuctionIprice", data);
};

//设置｜取消提醒
export const addOrCancelRemind = (data) => {
  return requestData("post", "/applet/AAuction/addOrCancelRemind", data);
};

//开户校验证件
export const OCRImageRecognition = (params) => {
  return requestData("get", "/applet/OCRImageRecognition", params);
};
//开户校验证件
export const queryOccupation = () => {
  return requestData("post", "/snb/snbApi/queryOccupation");
};
//获取银行列表
export const queryBankCategory = () => {
  return requestData("post", "/snb/snbApi/queryBankCategory");
};
//获取支行列表
export const queryBankNum = (data) => {
  return requestData("post", "/snb/snbApi/queryBankNum", data);
};

//获取支行列表
export const sendSmsCodeForPersonalAccountOpen = (data) => {
  return requestData(
    "post",
    "/snb/snbApi/sendSmsCodeForPersonalAccountOpen",
    data
  );
};
//个人用户开户
export const personalAccountOpen = (data) => {
  return requestData("post", "/snb/snbApi/personalAccountOpen", data);
};

//企业用户开户
export const businessAccountOpen = (data) => {
  return requestData("post", "/snb/snbApi/businessAccountOpen", data);
};
//企业用户开户
export const getAuctionRank = (data) => {
  return requestData("post", "/applet/AAuction/getAuctionRank", data);
};
//发布获取保证金的情况
export const getPublishAuctionTradingMarginData = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/getPublishAuctionTradingMarginData",
    data
  );
};

export const snbGetAccountInfo = (data) => {
  return requestData("post", "/applet/newAOrder/snbGetAccountInfo", data);
};
export const readDynamicAuctionRule = (data) => {
  return requestData("post", "/applet/AAuction/readDynamicAuctionRule", data);
};
export const queryAccountOpenInfo = (data) => {
  return requestData("post", "/snb/snbApi/queryAccountOpenInfo", data);
};
//解绑银行卡
export const stewardMemberCardRelieve = (data) => {
  return requestData("post", "/snb/snbApi/stewardMemberCardRelieve", data);
};

export const businessBankCardPayCheckAgain = (data) => {
  return requestData("post", "/snb/snbApi/businessBankCardPayCheckAgain", data);
};

//个人-换绑银行卡
export const personalBankChange = (data) => {
  return requestData("post", "/snb/snbApi/personalBankChange", data);
};
//个人-换绑银行卡
export const addPersonalCard = (data) => {
  return requestData("post", "/snb/snbApi/addPersonalCard", data);
};
//公司-换绑银行卡
export const businessBankChange = (data) => {
  return requestData("post", "/snb/snbApi/businessBankChange", data);
};
//公司-换绑银行卡
export const addEnterpriseCard = (data) => {
  return requestData("post", "/snb/snbApi/addEnterpriseCard", data);
};
//提现发送验证码
export const sendSmsCodeForAccountWithdraw = (data) => {
  return requestData("post", "/snb/snbApi/sendSmsCodeForAccountWithdraw", data);
};
//提现
export const accountWithdraw = (data) => {
  return requestData("post", "/snb/snbApi/accountWithdraw", data);
};
//账户明细
export const queryAccountTransactionDetails = (data) => {
  return requestData(
    "post",
    "/snb/snbApi/queryAccountTransactionDetails",
    data
  );
};
//账户关联
export const getUserSnbMainAccountDetails = (data) => {
  return requestData("post", "/applet/user/getUserSnbMainAccountDetails", data);
};
//发送验证码
export const sendSnbRelevanceAccountSmsCode = (data) => {
  return requestData(
    "post",
    "/applet/user/sendSnbRelevanceAccountSmsCode",
    data
  );
};
//编辑
export const updateSnbRelevanceAccount = (data) => {
  return requestData("post", "/applet/user/updateSnbRelevanceAccount", data);
};
//新增
export const addSnbRelevanceAccount = (data) => {
  return requestData("post", "/applet/user/addSnbRelevanceAccount", data);
};
//解绑
export const deleteSnbRelevanceAccount = (data) => {
  return requestData("post", "/applet/user/deleteSnbRelevanceAccount", data);
};

//子账户详情
export const getSnbRelevanceAccountDetails = (data) => {
  return requestData(
    "post",
    "/applet/user/getSnbRelevanceAccountDetails",
    data
  );
};
//金融预审信息详情
export const getPreAuditDetails = (data) => {
  return requestData("post", "/jhydServe/preAudit/getPreAuditDetails", data);
};

//金融预审信息提交
export const submitPreAudit = (data) => {
  return requestData("post", "/jhydServe/preAudit/submitPreAudit", data);
};

export const getAccreditAndContractData2 = (data) => {
  return requestData(
    "post",
    "/jhydServe/advanceCredit/getAccreditAndContractData2",
    data
  );
};
export const startAdvanceCreditAccreditAuthorization = (data) => {
  return requestData(
    "post",
    "/jhydServe/advanceCredit/startAdvanceCreditAccreditAuthorization",
    data
  );
};
export const startAdvanceCreditContractAuthorization = (data) => {
  return requestData(
    "post",
    "/jhydServe/advanceCredit/startAdvanceCreditContractAuthorization",
    data
  );
};
export const batchStartSigning = (params) => {
  return requestData("get", "/applet/AContract/batchStartSigning", params);
};

export const getHsbPayUrl = (data) => {
  return requestData("post", "/jhydServe/advanceCredit/getHsbPayUrl", data);
};
export const uploadPaymentData = (data) => {
  return requestData(
    "post",
    "/jhydServe/advanceCredit/uploadPaymentData",
    data
  );
};

//动态竞价报名
export const dynamicAuctionApply = (data) => {
  return requestData("post", "/applet/AAuction/dynamicAuctionApply", data);
};
//动态竞价取消报名
export const dynamicCancelAuctionApply = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/dynamicCancelAuctionApply",
    data
  );
};
//动态竞价取消报名
export const getDynamicAuctionOfferPriceDetailsEnded = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/getDynamicAuctionOfferPriceDetailsEnded",
    data
  );
};

export const getDynamicAuctionOfferPriceDetailsAfoot = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/getDynamicAuctionOfferPriceDetailsAfoot",
    data
  );
};

export const dynamicAuctionOfferPrice = (data) => {
  return requestData("post", "/applet/AAuction/dynamicAuctionOfferPrice", data);
};

export const readAuctionNotice = (data) => {
  return requestData("post", "/applet/AAuction/readAuctionNotice", data);
};
export const getRuleList = (data) => {
  return requestData("post", "/applet/ACommon/getRuleList", data);
};
export const querySystemNotice = (data) => {
  return requestData("get", "/applet/ACommon/querySystemNotice", data);
};
export const sendLegalPersonAgree = (data) => {
  return requestData("post", "/applet/user/sendLegalPersonAgree", data);
};
export const getOperatorPhone = (data) => {
  return requestData("post", "/snb/snbApi/getOperatorPhone", data);
};
export const sendSmsCodeForBusinessAccountOpenAgain = (data) => {
  return requestData(
    "post",
    "/snb/snbApi/sendSmsCodeForBusinessAccountOpenAgain",
    data
  );
};
export const checkFailedBusinessAccountOpenAgain = (data) => {
  return requestData(
    "post",
    "/snb/snbApi/checkFailedBusinessAccountOpenAgain",
    data
  );
};
//新版（v2）竞拍中心
export const getNewHome5AuctionList = (data) => {
  return requestData("post", "/applet/AAuction/getNewHome5AuctionList", data);
};
export const getAuctionMarketStatus = (data) => {
  return requestData("post", "/applet/AAuction/getAuctionMarketStatus", data);
};
export const getAuctionReviewList = (data) => {
  return requestData("post", "/applet/AAuction/getAuctionReviewList", data);
};
export const getAuctionPreviewList = (data) => {
  return requestData("post", "/applet/AAuction/getAuctionPreviewList", data);
};
export const getSpecialList = (data) => {
  return requestData("get", "/applet/ACommon/getSpecialList", data);
};
export const closingDateList = (data) => {
  return requestData("get", "/applet/AAuction/closingDateList", data);
};
//数据会员支付
export const payMarketMemberBySpecial = (data) => {
  return requestData("post", "/market/userApi/payMarketMemberBySpecial", data);
};
//数据会员-用户详情
export const getUserDetails = (data) => {
  return requestData("post", "/market/userApi/getUserDetails", data);
};
//数据会员-公共接口
export const getCommonDetails = (data) => {
  return requestData("get", "/market/common/getCommonDetails", data);
};
//数据会员-大盘价格
export const getMarketPriceDetails = (data) => {
  return requestData("post", "/market/marketPrice/getMarketPriceDetails", data);
};
//数据会员-区域价格
export const getMarketPriceRegionDetails = (data) => {
  return requestData(
    "post",
    "/market/marketPrice/getMarketPriceRegionDetails",
    data
  );
};
//数据会员-历史价格列表
export const getMarketPriceHistoryList = (data) => {
  return requestData(
    "post",
    "/market/marketPrice/getMarketPriceHistoryList",
    data
  );
};
//数据会员-历史价格详情
export const getMarketPriceHistoryDetails = (data) => {
  return requestData(
    "post",
    "/market/marketPrice/getMarketPriceHistoryDetails",
    data
  );
};
//数据会员-获取首页资讯
export const getHomeIndustryNewsList = (data) => {
  return requestData("post", "/applet/ANews/getHomeIndustryNewsList", data);
};

//数据会员-点赞
export const industryNewsLike = (data) => {
  return requestData("post", "/applet/ANews/industryNewsLike", data);
};
//数据会员-实时汇率
export const getHomeExchangeRate = (data) => {
  return requestData("post", "/applet/ANews/getHomeExchangeRate", data);
};

//数据会员-柴油价格
export const getHomeDieselPrice = (data) => {
  return requestData("post", "/applet/ANews/getHomeDieselPrice", data);
};

//数据会员-世界集装箱运转指数
export const getHomeContainerIndex = (data) => {
  return requestData("post", "/applet/ANews/getHomeContainerIndex", data);
};

//数据会员- 柴油价格列表
export const getDieselPriceList = (data) => {
  return requestData("post", "/applet/ANews/getDieselPriceList", data);
};

//数据会员- 汇率
export const getExchangeRateList = (data) => {
  return requestData("post", "/applet/ANews/getExchangeRateList", data);
};
//数据会员- 汇率
export const getContainerIndexList = (data) => {
  return requestData("post", "/applet/ANews/getContainerIndexList", data);
};

//数据会员- 汇率
export const getIndustryNewsLabelList = (data) => {
  return requestData("post", "/applet/ANews/getIndustryNewsLabelList", data);
};
//获取进口集单可选分类树
export const getImportCollectionCategoryTree = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/getImportCollectionCategoryTree",
    data
  );
};
//进口集单报盘
export const getImportCollectionAccountList = () => {
  return requestData("post", "/applet/user/getImportCollectionAccountList");
};
export const importCollectionApply = (data) => {
  return requestData("post", "/applet/AAuction/importCollectionApply", data);
};
export const importCollectionEditApply = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/importCollectionEditApply",
    data
  );
};
//删除报盘
export const importCollectionDeleteApply = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/importCollectionDeleteApply",
    data
  );
};

//提交处理结果
export const importCollectionHandleApply = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/importCollectionHandleApply",
    data
  );
};

export const getImportCollectionApplyDetails = (data) => {
  return requestData(
    "post",
    "/applet/AAuction/getImportCollectionApplyDetails",
    data
  );
};

//上传发票
export const uploadInvoice = (data) => {
  return requestData("post", "/applet/newAOrder/uploadInvoice", data);
};
export const jhydServeUploadInvoice = (data) => {
  return requestData("post", "/jhydServe/loanApply/uploadInvoice", data);
};
//发票删除
export const deleteInvoice = (data) => {
  return requestData("post", "/applet/newAOrder/deleteInvoice", data);
};
//提货详情
export const getPickUpDetails = (data) => {
  return requestData("post", "/applet/newAOrder/getPickUpDetails", data);
};

//填写费用确认单的详情
export const getFeeConfirmDetails = (data) => {
  return requestData("post", "/applet/newAOrder/getFeeConfirmDetails", data);
};

//发送费用确认单
export const sendFeeConfirm = (data) => {
  return requestData("post", "/applet/newAOrder/sendFeeConfirm", data);
};

//费用确认单预览
export const generateFeeConfirmUrl = (data) => {
  return requestData("post", "/applet/newAOrder/generateFeeConfirmUrl", data);
};

//上传提货单
export const uploadOutOrder = (data) => {
  return requestData("post", "/applet/newAOrder/uploadOutOrder", data);
};

//支付获取账户
export const snbCheckOrder = (data) => {
  return requestData("post", "/applet/newAOrder/snbCheckOrder", data);
};

//支付
export const payFeeConfirm = (data) => {
  return requestData("post", "/applet/newAOrder/payFeeConfirm", data);
};

//支付
export const getPickUpWeight = (data) => {
  return requestData("post", "/applet/newAOrder/getPickUpWeight", data);
};

//申请提货
export const applyPickUp = (data) => {
  return requestData("post", "/applet/newAOrder/applyPickUp", data);
};

//2025.6新版首页
export const getNewHome5Data = (data) => {
  return requestData("post", "/applet/AAuction/getNewHome5Data", data);
};

export const getCategoryTreeNew = (params) => {
  return requestData("get", "/applet/ACommon/getCategoryTree", params);
};

export const sellerPayServiceCharge = (data) => {
  return requestData("post", "/applet/newAOrder/sellerPayServiceCharge", data);
};
//定金支付
export const snbPayOrderDeposit = (data) => {
  return requestData("post", "/applet/newAOrder/snbPayOrderDeposit", data);
};
//全款支付
export const snbPayOrder = (data) => {
  return requestData("post", "/applet/newAOrder/snbPayOrder", data);
};
//全款支付
export const getCurrentMarketStatus = (data) => {
  return requestData("post", "/applet/AAuction/getCurrentMarketStatus", data);
};
//获取还款记录
export const getUserLoanApplyList = (data) => {
  return requestData("post", "/jhydServe/loanApply/getUserLoanApplyList", data);
};
//还款
export const applyLoanRepayment = (data) => {
  return requestData("post", "/jhydServe/loanApply/applyLoanRepayment", data);
};
//还款记录
export const getLoanRepaymentRecord = (data) => {
  return requestData(
    "post",
    "/jhydServe/loanApply/getLoanRepaymentRecord",
    data
  );
};
//提货记录
export const getStoreInfoList = (data) => {
  return requestData("post", "/szwrServe/storeInfo/getStoreInfoList", data);
};

export const getStoreInfoDetails = (data) => {
  return requestData("post", "/szwrServe/storeInfo/getStoreInfoDetails", data);
};

export const applyOutStore = (data) => {
  return requestData("post", "/szwrServe/storeInfo/applyOutStore", data);
};
export const getOutStoreInfoList = (data) => {
  return requestData("post", "/szwrServe/storeInfo/getOutStoreInfoList", data);
};
export const orderConfirmShipment = (data) => {
  return requestData("post", "/jhydServe/loanApply/orderConfirmShipment", data);
};
// 报名的竞价|| 点赞的文章
export const getUserAttention = (params) => {
  return requestData("get", "/applet/AAUser/getUserAttention", params);
};

export const updatePassWord = (data) => {
  return requestData("post", "/applet/AUser/user/updatePassWord", data);
};

export const getPublishImportPeruSquidCondition = () => {
  return requestData(
    "post",
    "/applet/AAuction/getPublishImportPeruSquidCondition"
  );
};
export const computeRetainage = (data) => {
  return requestData("post", "/applet/newAOrder/computeRetainage", data);
};

export const initiateRetainage = (data) => {
  return requestData("post", "/applet/newAOrder/initiateRetainage", data);
};
//多退少补相关
export const startPullGoodsSigning = (params) => {
  return requestData("get", "/applet/AContract/startPullGoodsSigning", params);
};
//分批拉货定金支付
export const snbPaySppDeposit = (data) => {
  return requestData("post", "/applet/newAOrder/snbPaySppDeposit", data);
};
//获取最大可支付货款重量
export const getSppGoodsPayMaxWeight = (data) => {
  return requestData("post", "/applet/newAOrder/getSppGoodsPayMaxWeight", data);
};
//获取填写重量对应货款
export const getSppGoodsPayAmount = (data) => {
  return requestData("post", "/applet/newAOrder/getSppGoodsPayAmount", data);
};

//苏商银行支付分批支付&拉货货款
export const snbPaySppGoods = (data) => {
  return requestData("post", "/applet/newAOrder/snbPaySppGoods", data);
};

export const getOspMaxWeight = (data) => {
  return requestData("post", "/applet/newAOrder/getOspMaxWeight", data);
};
export const applyOspPickUp = (data) => {
  return requestData("post", "/applet/newAOrder/applyOspPickUp", data);
};

export const getOrderRefundCollectDetails = (data) => {
  return requestData(
    "post",
    "/applet/newAOrder/getOrderRefundCollectDetails",
    data
  );
};
export const startBalanceSigning = (params) => {
  return requestData("get", "/applet/AContract/startBalanceSigning", params);
};

export const sellerPayOrderRefund = (data) => {
  return requestData("post", "/applet/newAOrder/sellerPayOrderRefund", data);
};

export const buyerPayOrderCollect = (data) => {
  return requestData("post", "/applet/newAOrder/buyerPayOrderCollect", data);
};
export const sellerPayOrderCollectServiceCharge = (data) => {
  return requestData(
    "post",
    "/applet/newAOrder/sellerPayOrderCollectServiceCharge",
    data
  );
};
export const snbPaySppSellerServiceCharge = (data) => {
  return requestData(
    "post",
    "/applet/newAOrder/snbPaySppSellerServiceCharge",
    data
  );
};
export const downloadSignFile2 = (params) => {
  return requestData("get", "/applet/AContract/downloadSignFile2", params);
};



// WEBPACK FOOTER //
// ./src/request/api.js